import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  private static JAVA_BASE_URL: string;
  private static NODE_BASE_URL: string;
  private static DOCUMENT_SERVICE_URL: string;
  private static ACTIVATION_LINK: string;
  private static KNOLLI_CHAT_URL: string;
  private static CURR_ENV: boolean;


  static setUrls(environment: any) {
    this.JAVA_BASE_URL = environment.JAVA_BASE_URL;
    this.NODE_BASE_URL = environment.NODE_BASE_URL;
    this.DOCUMENT_SERVICE_URL = environment.DOCUMENT_SERVICE_URL;
    this.ACTIVATION_LINK = environment.ACTIVATION_LINK;
    this.CURR_ENV = environment.production;
    this.KNOLLI_CHAT_URL = environment.KNOLLI_CHAT_URL;
  }

  static getBaseUrl(type: any): any {
    let url = '';
    switch (type) {
      case 'JAVA': {
        url = this.JAVA_BASE_URL;
      }
                   break;
      case 'NODE': {
        url = this.NODE_BASE_URL;
      }
                   break;
      case 'DOCUMENT': {
        url = this.DOCUMENT_SERVICE_URL;
      }
                       break;
      case 'ACTIVATION_LINK': {
        url = this.ACTIVATION_LINK;
      }
                              break;
      case 'KNOLLI': {
        url = this.KNOLLI_CHAT_URL;
      }
      break;
    }
    return url;
  }

  static isProdEnv(){
    return this.CURR_ENV;
  }
}
